import React, { useState, useEffect, useContext } from "react";
import { getManuals } from "../../../services/Manuals/getManuals";
import arrow from "../../../images/Arrow-Right.png";
import * as styles from "./manuals.module.scss";
import { getAllCategoriesManual } from "../../../services/Categories/getAllCategoriesManual";

const ManualsComponent = () => {
  const [productNameInput, setProductNameInput] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [manuals, setManuals] = useState([]);
  const [filteredManuals, setFilteredManuals] = useState([]);
  const [showNoResultsMessage, setShowNoResultsMessage] = useState(false);

  useEffect(() => {
    getAllCategoriesManual()
      .then((receivedCategories) => {
        if (receivedCategories && receivedCategories.length > 0) {
          setCategories(receivedCategories);
        } else {
          console.log("No se recibieron categorías");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    const fetchManuals = async () => {
      try {
        console.log("Fetching all manuals");
        const manualsData = await getManuals();
        console.log("All manuals fetched:", manualsData);
        setManuals(manualsData);
      } catch (error) {
        console.error("Error fetching manuals:", error);
      }
    };

    fetchManuals();
  }, []);

  const handleCategoryChange = async (value) => {
    setSelectedCategory(value);
    setProductNameInput("");
    if (value === "-") {
      setFilteredManuals([]);
    } else {
      await handleSearch(value);
    }
  };

  const handleSearch = async (category) => {
    try {
      console.log("Fetching manuals for category:", category);
      const manualsData = await getManuals(category);
      console.log("Manuals fetched:", manualsData);
      setFilteredManuals(manualsData);
      setShowNoResultsMessage(manualsData.length === 0);
    } catch (error) {
      console.error("Error fetching manuals:", error);
    }
  };

  const handleProductNameInputChange = (e) => {
    const value = e.target.value;
    setProductNameInput(value);
    setSelectedCategory("");
    if (value === "") {
      setFilteredManuals([]);
      setShowNoResultsMessage(false);
    } else {
      const filtered = manuals.filter((manual) =>
        manual.manual_name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredManuals(filtered);
      setShowNoResultsMessage(filtered.length === 0);
    }
  };

  const handleOpenManual = (manualUrl) => {
    if (manualUrl) {
      window.open(manualUrl, "_blank");
    } else {
      console.error("No se proporcionó la URL del manual");
    }
  };

  console.log(manuals);

  return (
    <section className={`${styles.SectionContainer} section`}>
      <div className={`${styles.mainContainer} container`}>
        <div className={styles.intro}>
          <h2>Búscalo por nombre o categoría</h2>
        </div>
        <div className={styles.SelectContainer}>
          <div className={styles.SimpleSelect}>
            <label>
              <p>Categorías</p>
            </label>
            <select
              value={selectedCategory}
              onChange={(e) => handleCategoryChange(e.target.value)}
              style={{
                cursor: "pointer",
              }}
            >
              <option value="-">-</option>
              {categories?.map((category) => (
                <option key={category.id} value={category.name}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>

          <div className={styles.SimpleInput}>
            <label>
              <p>Ingresar código de producto</p>
            </label>
            <input
              type="text"
              value={productNameInput}
              onChange={handleProductNameInputChange}
              placeholder="Ejemplo: PE-HG26M"
            />
          </div>
        </div>
        <div className={styles.ResultadosContainer}>
          {filteredManuals.length > 0 ? (
            <div className={styles.ContainerRow}>
              <div className={styles.TitleContainer}>
                <h3>Resultados</h3>
              </div>
              {filteredManuals.map((manual) => (
                <div key={manual.id} className={styles.ManualContainer}>
                  <div className={styles.ResultsItem}>
                    <div className={styles.TextContainer}>
                      <p>{manual.manual_name}</p>
                    </div>
                    <div className={styles.ButtonContainer}>
                      <button
                        onClick={() => handleOpenManual(manual.manual_href)}
                      >
                        Ver más
                        <img
                          src={arrow}
                          alt="Icono de búsqueda"
                          style={{ cursor: "pointer" }}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            showNoResultsMessage && (
              <div className={styles.NoResultsMessage}>
                <p>No se encontraron resultados.</p>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default ManualsComponent;
